export const DataLayers = {
  postulacion: ({ idAviso, idPostulacion, idUsuario, estado, desdeEmail, avisoConPreguntas, actualizaCV }) => {
    /**
     * Debe dispararse cuando el usuario se postula a un Aviso exitosamente,
     * ya sea luego de haber hecho click en “Postularme” o “Responder”.
     *
     * El objetivo es trackear la postulación de un usuario, y sus detalles.
     */

    return {
      event: 'Postularse',
      idAviso,
      idPostulacion,
      idUsuario,
      estadoPostulacion: estado,
      tipo: desdeEmail ? 'Mail' : 'Simple',
      preguntas: avisoConPreguntas ? 'si' : 'no',
      actualizaCV: actualizaCV ? 'si' : 'no',
    }
  },
}
